import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path
        d='M6.7734375,5.41992188 L6.7734375,6.94433594 L5.80273438,6.94433594 L5.80273438,17.7929688 L6.7734375,17.7929688 L6.7734375,19.3173828 L3.8203125,19.3173828 L3.8203125,5.41992188 L6.7734375,5.41992188 Z M20.390625,5.41992188 L20.390625,19.3173828 L17.4375,19.3173828 L17.4375,17.7929688 L18.4150391,17.7929688 L18.4150391,6.94433594 L17.4375,6.94433594 L17.4375,5.41992188 L20.390625,5.41992188 Z M15.5,11 C16.3284271,11 17,11.6715729 17,12.5 C17,13.3284271 16.3284271,14 15.5,14 C14.6715729,14 14,13.3284271 14,12.5 C14,11.6715729 14.6715729,11 15.5,11 Z M12,11 C12.8284271,11 13.5,11.6715729 13.5,12.5 C13.5,13.3284271 12.8284271,14 12,14 C11.1715729,14 10.5,13.3284271 10.5,12.5 C10.5,11.6715729 11.1715729,11 12,11 Z M8.5,11 C9.32842712,11 10,11.6715729 10,12.5 C10,13.3284271 9.32842712,14 8.5,14 C7.67157288,14 7,13.3284271 7,12.5 C7,11.6715729 7.67157288,11 8.5,11 Z'
        fill={fillColor}
        fillRule='nonzero'
      />
    </svg>
  );
});

export default React.memo(Icon);
